import React from "react";

const PersonalInfoSection = ({
  name,
  setName,
  gender,
  setGender,
  dob,
  handleDobChange,
  age,
  setAge,
  email,
  setEmail,
}) => {
  const labelClass =
    "block font-fatfrank text-sas-primary md:text-lg font-bold";
  const inputClass =
    "w-full rounded-xl border border-slate-300 px-4 py-3 text-base font-semibold text-sas-primary-dark font-montserrat focus:outline-none focus:ring-2 focus:ring-sas-primary/30 bg-white";

  return (
    <>
      <div className="mb-4 grid md:grid-cols-2 gap-4 px-4">
        <div>
          <label className={labelClass} htmlFor="name">
            Name
          </label>
          <input
            className={inputClass}
            id="name"
            type="text"
            name="name"
            placeholder="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            autoComplete="off"
          />
        </div>
        <div>
          <label className={labelClass} htmlFor="gender">
            Sex at Birth
          </label>
          <select
            className={inputClass}
            id="gender"
            name="gender"
            value={gender}
            onChange={(e) => setGender(e.target.value)}
            required
          >
            <option value="" disabled>
              Select sex at birth
            </option>
            <option value="Female">Female</option>
            <option value="Male">Male</option>
            <option value="Intersex">Intersex</option>
            <option value="Prefer not to say">Prefer not to say</option>
          </select>
        </div>
        <div>
          <label className={labelClass} htmlFor="dob">
            Date of Birth
          </label>
          <input
            className={inputClass}
            id="dob"
            type="date"
            name="dob"
            placeholder="DD/MM/YYYY"
            value={dob}
            onChange={handleDobChange}
            required
            autoComplete="off"
          />
        </div>
        <div>
          <label className={labelClass} htmlFor="age">
            Age
          </label>
          <input
            className={inputClass}
            id="age"
            type="text"
            name="age"
            placeholder="Age"
            value={age}
            onChange={(e) => setAge(e.target.value)}
            readOnly
            autoComplete="off"
          />
        </div>
      </div>
      <div className="relative z-10 px-4">
        <label className={labelClass} htmlFor="email">
          Email
        </label>
        <input
          id="email"
          type="email"
          className={inputClass}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          autoComplete="off"
        />
      </div>
    </>
  );
};

export default PersonalInfoSection;
